import { render, staticRenderFns } from "./customize-features.vue?vue&type=template&id=27d6bfce&scoped=true&"
import script from "./customize-features.vue?vue&type=script&lang=js&"
export * from "./customize-features.vue?vue&type=script&lang=js&"
import style0 from "./customize-features.vue?vue&type=style&index=0&id=27d6bfce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d6bfce",
  null
  
)

component.options.__file = "customize-features.vue"
export default component.exports